// extracted by mini-css-extract-plugin
module.exports =  {"reset":"IScNrV","visuallyHidden":"cSuIrM"};